export default __webpack_public_path__ + "static/media/settings.ab50a5d6.svg";